import axios from 'axios'
import { getFirstErrorMessage, getErrorMessage, getErrorMessages } from '~/lib/axios'
import config from '../lib/config'
const {apiUri} = config.CONFIG
const APIURI = apiUri + '/customer/reservation'

export default {
  getFirstErrorMessage,
  getErrorMessage,
  getErrorMessages,
  async getBookingAvailability(payload) {
    const { data } = await axios.post(`${APIURI}/availability-date`, payload);
    return data;
  },
  async hold(slot, quantity) {
    slot = _.clone(slot)
    if (quantity) {
      slot.participants = quantity
    }
    const { data = {} } = await axios.post(`${APIURI}/hold`, slot);
    return data.data || {}
  },
  async unhold({id}) {
    try {
      const { data = {} } = await axios.delete(`${APIURI}/hold/${id}`);
      return data
    } catch (e) {
      //
    }
    return false
  }
}
